import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getThemeMode } from '../../../../../utils/helper';
import ChatFullScreenButton from '../../../../chatFullScreenButton';

function Help() {
  const { widgetConfig } = useSelector((state) => ({
    widgetConfig: state.messages.widgetConfig,
  }));
  const [isBgLight, setIsBgLight] = useState(false);
  
  useEffect(() => {
    if(widgetConfig?.config?.widgetId) {
      setIsBgLight(getThemeMode(widgetConfig?.widgetConfig?.lookAndFeel?.backgroundColor))
    }
  }, [widgetConfig])

  return (
    <>
      <div className='rcw-help'>
        <ChatFullScreenButton isBgLight={isBgLight} />
        <div className='rcw-help-header' style={{ background: widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor }}>
          <div className='rcw-help-title' style={{ color: isBgLight ? '#000000' : '#ffffff' }}>{widgetConfig?.widgetConfig?.helpSection?.title}</div>
        </div>
        <div className='rcw-help-body'>
          <iframe src={widgetConfig?.widgetConfig?.helpSection?.url} style={{
            height: 'calc(100% - 144px)',
            width: '100%',
            position: 'fixed',
            top: '64px',
            bottom: 0,
            right: 0,
            left: 0,
            border: 'none',
            paddingTop: '1px'
          }}></iframe>
          {/* <div className="">
            <header className="">
              <h2 className="">8 collections</h2>
            </header>
            <ul className="rcw-help-list">
              <li>
                <div data-testid="collection-card" role="button" tabindex="0" className="collection-card">
                  <div className="">
                    <p className="title">Video</p>
                    <p className="subtitle">Learn how to create videos in Synthesia</p>
                    <p className="article-count">
                      <span className="">63 articles</span>
                    </p>
                  </div>
                  <div className="">
                    <div className="">
                      <i color="linkColor" size="16" className="">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M5.42773 4.70898C5.46387 4.85254 5.53809 4.98828 5.65039 5.10059L8.54932 8L5.64893 10.9004C5.31689 11.2324 5.31689 11.7705 5.64893 12.1025C5.98096 12.4336 6.51904 12.4336 6.85107 12.1025L10.3516 8.60059C10.5591 8.39355 10.6367 8.10449 10.585 7.83691C10.5537 7.67578 10.4761 7.52246 10.3516 7.39844L6.85254 3.89941C6.52051 3.56738 5.98242 3.56738 5.65039 3.89941C5.43066 4.11816 5.35645 4.42871 5.42773 4.70898Z" fill="currentColor"></path>
                        </svg>
                      </i>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default Help;
